import NestedTracks from '@/components/app/NestedTracks/NestedTracks'

/**
 * App-wide overlays that should exist once per session (invokers use stable ids).
 * Feature toggles gate behaviour at the control site, not whether the shell is mounted.
 */
export function ModalHost(): JSX.Element {
	return <NestedTracks />
}
